import {Layout} from "../layouts";
import WebinarsContent from "@/components/webinars/webinars-content";
import ImageHero from "@/components/image-hero/image-hero";

const Webinars: React.FC = () => {
    return (
        <Layout page={"webinars"}>
          <ImageHero/>
            <WebinarsContent/>
        </Layout>
    )
};

export default Webinars;

